
import fs from 'fs';
import path from 'path';
import archiver from 'archiver';
import DecompressZip from 'decompress-zip';

// This shouldn't really be here, but it would be breaking to remove it.
// @deprecate the default ignore list here.
const DEFAULT_IGNORE = [
  '**/bower_components/**',
  '**/node_modules/**',
  '**/target/**',
];

/**
 * @private
 * @param {string} dir The dir to zip
 * @param {string} saveAs Name of zip file that will be created.
 * @returns {Promise.<string>} saveAs string
 */
const zipDir = (dir, saveAs, ignore = DEFAULT_IGNORE) =>
  new Promise((resolve, reject) => {
    const output = fs.createWriteStream(saveAs);
    const archive = archiver('zip');
    output.on('close', () => resolve(saveAs));

    archive.on('error', (err) => {
      reject(err);
    });

    archive.pipe(output);

    archive.glob('**', {
      dot: true,
      cwd: dir,
      ignore,
    });

    archive.finalize();
  });

/**
 * Zips array of files into a zip file.
 * @private
 * @param {Array.<string>} files
 * @param {string} saveAs
 * @returns {Promise.<string>} saveAs filename.
 */
const zipFiles = (files, saveAs) =>
  new Promise((resolve, reject) => {
    const output = fs.createWriteStream(saveAs);
    const archive = archiver('zip');
    output.on('close', () => resolve(saveAs));

    archive.on('error', (err) => {
      reject(err);
    });

    archive.pipe(output);

    files.forEach((filename) => {
      archive.file(filename, { name: path.basename(filename) });
    });

    archive.finalize();
  });

const unzip = (zipPath, dirPath) => {
  const unzipper = new DecompressZip(zipPath);
  return new Promise((resolve, reject) => {
    unzipper.on('error', reject);
    unzipper.on('extract', resolve);
    unzipper.extract({ path: dirPath });
  });
};

export {
    zipDir,
    zipFiles,
    unzip,
};
